import React, {useEffect} from 'react';
import {Link, useNavigate, useParams} from 'react-router';

import {useConfirmMutation} from '@/api';
import CURRENT_USER from '@/api/queries/currentUser';

// 確認リンクではログインしない。確認が済んだらログイン画面へ進み、パスワードでログインしてもらう（#160）
export const CONFIRMED_NOTICE =
  '会員登録の確認が完了しました。ログインしてください。';

const Confirmation = () => {
  const {token} = useParams<{token: string}>();
  const navigate = useNavigate();
  const [confirm, {data, loading}] = useConfirmMutation({
    update: (cache, {data}) => {
      if (!data.confirm?.error) {
        // サーバーはセッションを破棄するので、画面のログイン状態も外す
        cache.writeQuery({query: CURRENT_USER, data: {currentUser: null}});
        navigate('/signin', {replace: true, state: {notice: CONFIRMED_NOTICE}});
      }
    },
  });

  useEffect(() => {
    void confirm({variables: {token}});
  }, [confirm, token]);

  return (
    <div className="mx-auto w-[400px] pb-[200px] pt-[90px] text-center">
      {(!data || loading) && (
        <h1 className="mb-[70px] text-center text-[26px] font-medium text-neutral-700">
          会員登録メールアドレス確認中
        </h1>
      )}
      {data?.confirm?.error && (
        <>
          <div className="mb-4 rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">
            <p>{data.confirm.error}</p>
          </div>
          <Link to="/signin" className="text-primary">
            ログイン画面へ
          </Link>
        </>
      )}
    </div>
  );
};

export {Confirmation};
